import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { isSupabaseConfigured } from "../services/supabase";
import Spin from "./common/Spin";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (!isSupabaseConfigured()) return children;

  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", width: "100%" }}>
        <Spin />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return children;
}

export function AdminRoute({ children }) {
  const { isAdmin, loading } = useAuth();

  if (!isSupabaseConfigured()) return children;

  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", width: "100%" }}>
        <Spin />
      </div>
    );
  }

  if (!isAdmin) return <Navigate to="/" replace />;

  return children;
}
